import { useReadPresetApi } from '@aibees/shared/api';
import { TransferListPresetValue } from '@aibees/shared/features';
import { useEffect } from 'react';
import useTransferListStore from '../store/transfer-list-store';

export function useLoadTransferListPreset(id?: string) {
  const store = useTransferListStore();
  const { data } = useReadPresetApi<TransferListPresetValue>(id!, {
    enabled: !!id,
  });

  useEffect(() => {
    if (data?.value.included) store.setIncluded(data?.value.included);
    if (data?.value.excluded) store.setExcluded(data?.value.excluded);
  }, [data]);
}
